import { SpsIntercomRootController } from './sps-intercom-root.controller';
const template = require('./sps-intercom-root.html');
const angular = require('angular');

function SpsIntercomRootDirective() {
    return {
        scope: {},
        restrict: 'E',
        template: template,
        controller: SpsIntercomRootController,
        controllerAs: 'ctrl',
    };

}

export default angular
    .module('spsng.components.sps-intercom-root', [])
    .directive('spsIntercomRoot', SpsIntercomRootDirective)
    .name;
